import React from "react";

export const QKStatusBar: React.FC = () => {
  return <></>;
};
